import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  en: {
    translation: {
      news: "News",
      announcement: "Announcements",
      filters: "Filters",
      category: "Category",
      wholesale_price: "Wholesale Price",
      retail_price: "Retail Price",
      field_price: "Field Price",
      type: "Type",
      item: "Item",
      address: "Address",
      location: "Location",
      price: "Price",
      price_list: "Price List",
      time_series: "Timeseries Price",
      graph: "Graph",
      table: "Table",
      and: "and",
      discussion_forum: "Discussion Forum",
      signin: "Signin",
      signup: "Signup",
      forgot_password: "Forgot Password",
      reset_password: "Reset Password",
      signout: "Signout",
      see_full_table: "See full table",
      add_new_forum: "Add New Forum",
      add_new_price: "Add New Price",
      data_not_available: "Data not available",
      welcome: "Welcome",
      please_signin: "Please sign in",
      username: "Username",
      email: "Email",
      password: "Password",
      confirm_password: "Confirm Password",
      password_personal:
        "Your password can't be too similar to your other personal information.",
      password_length: "Your password must contain at least 8 characters.",
      password_common: "Your password can’t be a commonly used password.",
      password_numeric: "Your password can’t be entirely numeric.",
      Name: "Name",
      Topic: "Topic",
      Description: "Disres",
      Link: "Link",
      add: "Add",
      cancel: "Cancel",
      AddPrice: "Add Price",
      could_not_send_reset_token:
        "email not correct or email  is not registered",
      reset_successful:
        "Your password has been reset. Please login with your new password",
      reset_link_sent:
        "Password Reset Link has been sent. Please check your email",
      reset_failed:
        "Could not reset your password. Please try restart the process ",
      gapanapa: "GaPaNaPa",
    },
  },
  ne: {
    translation: {
      news: " समाचार ",
      announcement: "सुचना",
      filters: "फिल्टरहरू",
      category: "वर्ग",
      wholesale_price: "थोक मूल्य",
      retail_price: "खुद्रा दाम",
      field_price: "क्षेत्र मूल्य",
      type: "प्रकार",
      item: "वस्तु",
      address: "ठेगाना",
      location: " स्थान ",
      price: "मूल्य ",
      price_list: "मूल्य सूचि",
      time_series: "मूल्य श्रृंखला",
      graph: "ग्राफ",
      table: "टेबल ",
      and: "र",
      discussion_forum: "आफ्नो प्रश्न र विचार राख्नुहोस",
      signin: "साईन ईन ",
      signup: " साइन अप ",
      forgot_password: " पासवर्ड भुल्नु भयो ",
      reset_password: " रिसेट गर्नुहोस् ",
      signout: "साइनआउट ",
      see_full_table: "पूरा टेबल हेर्नुहोस्",
      add_new_forum: " नयाँ फोरम थप्नुहोस् ",
      add_new_price: " नयाँ मूल्य थप्नुहोस् ",
      data_not_available: "डाटा उपलब्ध छैन",
      welcome: "स्वागत छ",
      please_signin: "कृपया तपाईको खातामा साईन ईन गर्नुहोस्",
      username: " प्रयोगकर्ता नाम ",
      email: " ईमेल ",
      password: "पासवर्ड",
      confirm_password: " पासवर्ड सुनिश्चित गर्नुहोस ",
      password_personal:
        " तपाईको पासवर्ड तपाईको अन्य व्यक्तिगत जानकारीसँग यस्तै हुन सक्दैन।",
      password_length: "तपाईको पासवर्ड कम्तिमा ८ अक्षरको हुनु पर्छ।",
      password_common:
        " तपाईको पासवर्ड साधारणतया प्रयोग भएको पासवर्ड हुन सक्दैन।",
      password_numeric: " तपाईंको पासवर्ड पूर्ण संख्यात्मक हुन सक्दैन।",
      Name: " नाम ",
      Topic: " शीर्षक ",
      Description: " वर्णन ",
      Link: " लिंक ",
      add: " थप्नुहोस् ",
      cancel: "रद्द गर्नुहोस्",
      Submit: "बुझाउनुहोस्",
      Subscribe: " सदस्यता लिनुहोस् ",
      Unsubscribe: " सदस्यता रद्द गर्नुहोस् ",
      Unit: " एकाइ ",
      Date: " मिति ",
      MaxPrice: " अधिकतम मूल्य ",
      MinPrice: " न्यूनतम मूल्य ",
      AddPrice: " मूल्य थप्नुहोस् ",
      Signout: " साइनआउट ",
      could_not_send_reset_token: "ईमेल सहि छैन वा ईमेल दर्ता गरिएको छैन",
      reset_successful:
        " तपाईंको पासवर्ड बेन रीसेट भयो। कृपया तपाईको नयाँ पासवर्डका साथ लगईन गर्नुहोस्",
      reset_link_sent:
        "पासवर्ड रिसेट लिंक पठाइएको छ। कृपया तपाईंको ईमेल जाँच गर्नुहोस्",
      reset_failed:
        " तपाईंको पासवर्ड रिसेट गर्न सकेन। कृपया प्रक्रिया पुनः सुरु गर्न प्रयास गर्नुहोस्",
      gapanapa: " गापा नपा",
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
